import {FunctionInfo} from './FunctionInfo';

export class ImportFunctionsRequest
{
    constructor(
            public readonly designId:number, 
            public readonly designSnapshotId:number, 
            public readonly functions:FunctionInfo[], 
            public readonly designVersion:number
        )
    {}
}
